/* =========================================================================
   BUMPY VICE — fiche produit
   Sélecteur de variantes (rendu serveur via la Section Rendering API) et
   galerie.
   ========================================================================= */
(function () {
  'use strict';

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* =======================================================================
     Sélecteur de variantes
     ======================================================================= */
  function initVariants(root) {
    if (root.dataset.variantsReady === 'true') return;
    root.dataset.variantsReady = 'true';

    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.productUrl;
    var idInput = root.querySelector('form[data-product-form] input[name="id"]');

    var inputs = $$('[data-option-index]', root);
    if (!inputs.length || !idInput) return;

    var data = null;
    try {
      data = JSON.parse($('[data-variants-json]').textContent);
    } catch (e) {
      return;
    }

    var pending = null;

    function selectedOptions() {
      var values = [];
      inputs.forEach(function (el) {
        if (el.checked) values[parseInt(el.dataset.optionIndex, 10)] = el.value;
      });
      return values;
    }

    function findVariant(values) {
      return data.find(function (v) {
        return v.options.every(function (opt, i) { return opt === values[i]; });
      });
    }

    function refreshAvailability(values) {
      inputs.forEach(function (input) {
        var idx = parseInt(input.dataset.optionIndex, 10);
        var exists = data.some(function (v) {
          if (!v.available) return false;
          return v.options.every(function (opt, i) {
            return i === idx ? opt === input.value : opt === values[i];
          });
        });
        input.disabled = !exists;
      });
    }

    function update() {
      var values = selectedOptions();
      var variant = findVariant(values);

      refreshAvailability(values);

      inputs.forEach(function (input) {
        if (!input.checked) return;
        var group = input.closest('.variant-group');
        var label = group && group.querySelector('.variant-group__value');
        if (label) label.textContent = input.value;
      });

      if (!variant) {
        idInput.value = '';
        return;
      }

      idInput.value = variant.id;

      var url = productUrl + '?variant=' + variant.id;
      history.replaceState({}, '', url);

      if (variant.media_id) {
        var thumb = $('[data-media-id="' + variant.media_id + '"]');
        if (thumb) thumb.click();
      }

      if (pending) pending.abort();
      pending = new AbortController();

      fetch(url + '&section_id=' + sectionId, { signal: pending.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price-block]', '[data-buy-block]', '[data-stock-block]', '[data-sku-block]'].forEach(function (sel) {
            var current = $(sel);
            var fresh = doc.querySelector(sel);
            if (current && fresh) current.innerHTML = fresh.innerHTML;
          });

          var stickyPrice = $('[data-sticky-price]');
          var freshSticky = doc.querySelector('[data-sticky-price]');
          if (stickyPrice && freshSticky) stickyPrice.innerHTML = freshSticky.innerHTML;
        })
        .catch(function (err) { if (err.name !== 'AbortError') { /* on garde l'affichage courant */ } });
    }

    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) update();
    });

    refreshAvailability(selectedOptions());
  }

  /* =======================================================================
     Galerie : miniatures et flèches

     Deux correctifs (v1.2) :
     1) Les visuels autres que le premier étaient en loading="lazy" dans un
        conteneur à défilement horizontal masqué : le navigateur ne les
        considérait jamais comme visibles et ne les chargeait donc jamais,
        d'où un cadre vide. On les repasse en « eager ».
     2) Le défilement « smooth » vers une diapo était annulé par
        scroll-snap: x mandatory (retour à la première image). On positionne
        désormais le défilement directement.
     ======================================================================= */
  function eagerizeSlides(gallery) {
    $$('[data-gallery-slides] img[loading="lazy"]', gallery).forEach(function (img) {
      img.setAttribute('loading', 'eager');
      if (!img.complete && img.srcset) img.srcset = img.srcset;
    });
  }

  function initGallery(gallery) {
    if (gallery.dataset.galleryReady === 'true') return;
    gallery.dataset.galleryReady = 'true';

    var slides = $('[data-gallery-slides]', gallery);
    var thumbs = $$('[data-media-id]', gallery);
    if (!slides) return;

    eagerizeSlides(gallery);
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { eagerizeSlides(gallery); }, { once: true });
    }
    setTimeout(function () { eagerizeSlides(gallery); }, 1200);

    function markActive(mediaId) {
      thumbs.forEach(function (t) {
        t.setAttribute('aria-current', String(t.dataset.mediaId === String(mediaId)));
      });
    }

    function goTo(mediaId) {
      var slide = slides.querySelector('[data-slide-media="' + mediaId + '"]');
      if (!slide) return;
      eagerizeSlides(gallery);
      slides.scrollLeft = slide.offsetLeft - slides.offsetLeft;
      markActive(mediaId);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(thumb.dataset.mediaId); });
    });

    var prev = $('[data-gallery-prev]', gallery);
    var next = $('[data-gallery-next]', gallery);

    function step(dir) {
      var children = Array.prototype.slice.call(slides.children);
      if (!children.length) return;
      var w = slides.clientWidth || 1;
      var index = Math.round(slides.scrollLeft / w) + dir;
      if (index < 0) index = children.length - 1;
      if (index > children.length - 1) index = 0;
      var slide = children[index];
      if (!slide) return;
      eagerizeSlides(gallery);
      slides.scrollLeft = slide.offsetLeft - slides.offsetLeft;
      markActive(slide.dataset.slideMedia);
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    slides.addEventListener('scroll', function () {
      var index = Math.round(slides.scrollLeft / (slides.clientWidth || 1));
      var slide = slides.children[index];
      if (!slide) return;
      markActive(slide.dataset.slideMedia);
    }, { passive: true });
  }

  /* =======================================================================
     Démarrage
     ======================================================================= */
  function boot() {
    $$('[data-product-root]').forEach(initVariants);
    $$('[data-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
